"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeAll = exports.mergeBy = exports.merge = void 0;

var _is = require("../is/is");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var _merge = function _merge(fn, source) {
  var result = {};

  for (var i = 0, length = source.length; i < length; i++) {
    var sourceEntries = Object.entries(source[i]);

    if ((0, _is.is)(fn)) {
      result = fn(result, source[i]);
    } else {
      for (var j = 0, sourceEntriesLength = sourceEntries.length; j < sourceEntriesLength; j++) {
        var _sourceEntries$j = _slicedToArray(sourceEntries[j], 2),
            key = _sourceEntries$j[0],
            value = _sourceEntries$j[1];

        result[key] = value;
      }
    }
  }

  return result;
};
/**
 * Combine from left to right, 2 or more objects into a new single one.
 * Properties will be shallow copied. Those with the same name will be
 * overwriten by right most object.
 *
 * @tag Object
 * @signature ( ...source: Object[] ): Object
 *
 * @param   {Object[]}  source  Array of objects
 *
 * @return  {Object}
 *
 * @example
 * merge({a: "lorem"}, {b: "ipsum", c: 41}, {c: 42, b: undefined})
 * // => { a: "lorem", b: "ipsum", c: 42 }
 */


var merge = function merge() {
  for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
    params[_key] = arguments[_key];
  }

  // @signature (obj1) => (obj2)
  if (params.length <= 1) {
    return function (obj2) {
      return _merge(null, [params[0], obj2]);
    };
  } // @signature (obj1, obj2)


  return _merge.apply(void 0, [null].concat(params));
};

exports.merge = merge;

var mergeBy = function mergeBy() {
  for (var _len2 = arguments.length, params = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    params[_key2] = arguments[_key2];
  }

  // @signature (fn) => (source)
  if (params.length <= 1) {
    return function (source) {
      return _merge(params[0], source);
    };
  } // @signature (fn, source)


  return _merge.apply(void 0, params);
};

exports.mergeBy = mergeBy;

var mergeAll = function mergeAll(source) {
  return _merge(null, source);
};

exports.mergeAll = mergeAll;